export const externalVideo = () => {
  const embeddedVideos = document.querySelectorAll("[data-wm-external-video]");

  if (!embeddedVideos.length) {
    return;
  }

  const buttonText = {
    en: "Please accept marketing cookies to watch this video",
    nl: "Accepteer marketingcookies om deze video te bekijken",
    fr: "Veuillez accepter les cookies marketing pour regarder cette vidéo",
    de: "Bitte akzeptieren Sie Marketing-Cookies, um dieses Video anzusehen",
    it: "Per favore accetta i cookie di marketing per guardare questo video",
    pl: "Aby obejrzeć ten film, zaakceptuj marketingowe pliki cookie",
    es: "Acepte las cookies de marketing para ver este vídeo",
  };

  embeddedVideos.forEach((video) => {
    const videoUrl = video.dataset.wmExternalVideo;

    const videoTPL = `
      <div class="bg-wm-lightblue-video h-auto w-full aspect-video flex items-center justify-center
        cookieconsent-optout-marketing">
        <button
          type="button"
          onclick="Cookiebot.renew()"
          class="text-wm-orange hover:underline">
          ${buttonText[wemove.page.language.iso]}
        </button>
      </div>

      <iframe
        width="560"
        height="315"
        class="h-auto w-full aspect-video"
        data-wm-iframe
        data-cookieblock-src="${videoUrl}"
        data-cookieconsent="marketing"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encryptewd-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen>
      </iframe>`;

    var div = document.createElement("div");
    div.innerHTML = videoTPL.trim();

    video.appendChild(div);
    video.querySelector("[data-wm-iframe]").src = "";
    video.hidden = false;
  });
};
